import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { EnvironmentService } from '@sg/common/src';
import { AsyncTracker } from '@sg/utils/src';
import { CookiesSettingsModel } from './CookiesSetting.model';

@Component({
  selector: 'sg-cookies-settings',
  templateUrl: './cookies-settings.component.html',
  styleUrls: ['./cookies-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CookiesSettingsComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class CookiesSettingsComponent implements ControlValueAccessor {
  tracker = new AsyncTracker();

  isDisabled: boolean = false;
  appName = this.env.appName;
  /** Mixpanel is a lender-app-only vendor; its consent panel must not appear in other apps. */
  isLenderApp = this.env.appNameWithoutPrefix === 'lender';

  private _value: CookiesSettingsModel;
  set value(val: CookiesSettingsModel) {
    this._value = val;
    this._onChange(val);
    this._onTouched(val);
  }
  get value() {
    return this._value;
  }

  private _onChange: any = () => {};
  private _onTouched: any = () => {};

  constructor(private env: EnvironmentService) {}

  writeValue(obj: CookiesSettingsModel): void {
    this._value = obj;
  }

  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  toggleAnalyticalCookie(value: boolean) {
    this.value = { ...this._value, analytical: value };
    this._onChange(this.value);
    this._onTouched();
  }

  toggleMixpanelCookie(value: boolean) {
    this.value = { ...this._value, mixpanel: value };
    this._onChange(this.value);
    this._onTouched();
  }
}
